export interface IRandomSentenceGenerator {
    generateSettingName(): string;
}
